export default __webpack_public_path__ + "static/media/title_vi_pc@2x.6078af11.png";